import Modal from 'bootstrap/js/src/modal';

class RegisterDataController {
    /*@ngInject*/
    constructor() {
        if (window.titles) {
            this.titles = window.titles.titles;
        }
        if (window.countries) {
            this.countries = window.countries.countries;
        }
        this.selectedTitle = '';
        this.title = {
            selected: null
        };
        this.selectedCountry = '';
        this.country = {
            selected: null
        };
        this.fashionNewsletter;
        this.yourClub;
        this.yourClubDisabled;
        this.requestPending = false;
        this.modalFashion = $('#modal__fashion');
        this.modalClub = $('#modal__club');
        this.modalFashionClub = $('#modal__fashion-club');

        if (this.modalFashion.length) {
            new Modal(this.modalFashion[0], {
                show: false
            });
        }
        if (this.modalClub.length) {
            new Modal(this.modalClub[0], {
                show: false
            });
        }
        if (this.modalFashionClub.length) {
            new Modal(this.modalFashionClub[0], {
                show: false
            });
        }
    }

    titleChanged(item) {
        this.selectedTitle = item.code;
    }

    countryChanged(item) {
        this.selectedCountry = item.code;
        this.yourClubDisabled = !item.yourClubRegistrationEnabled;
    }

    setTitleCode(code) {
        this.selectedTitle = code;
        for (let entry of this.titles) {
            if (code === entry.code) {
                this.title.selected = entry;
                break;
            }
        }
    }

    setCountryCode(code) {
        if (code) {
            for (let entry of this.countries) {
                if (code === entry.code) {
                    this.country.selected = entry;
                    this.countryChanged(entry);
                    break;
                }
            }
        }
    }

    submit(form) {
        if (this.fashionNewsletter) {
            if (this.yourClub || this.yourClubDisabled) {
                this.requestPending = true;
                form.$$element.submit();
            } else {
                this.modalClub.modal('show');
            }
        } else {
            if (this.yourClub || this.yourClubDisabled) {
                this.modalFashion.modal('show');
            } else {
                this.modalFashionClub.modal('show');
            }
        }
    }

    submitImmediate(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default RegisterDataController;
